import { DateTime } from 'luxon';

import { UnidentifiedDrivingState } from 'app/pages/hos/UnidentifiedDriving/types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const unidentifiedDrivingState: UnidentifiedDrivingState = {
  // Data filters
  vehicle: null,
  terminal: null,
  dateRange: [
    DateTime.local().minus({ days: 6 }).toISODate(), // From date
    DateTime.local().toISODate(), // To date
  ],
  isUnassigned: true,
  isClassified: false,
  // Sorting
  sortBy: '-event-time',
  sortField: 'event-time',
  // File export document type
  documentType: 'pdf',
  // Modal toggler states
  isToggleExportFileModal: false,
  isToggleAssignUnidDrivingModal: false,
  isToggleBulkAssignUnidDrivingModal: false,
  // API request status
  isInitializeFetchDataRequestPending: false,
  isInitializeFileExportRequestPending: false,
  // Pagination
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,
  // Data source
  exportFileData: [],
  refreshDataCount: 0,
  selectedUnidEvents: [],
  unidentifiedDrivingEvents: [],
  decoratedUnidentifiedDrivingEvents: [],
};
